const s = {
  name: "FastPayout",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 26.1" style="enable-background:new 0 0 40 26.1;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M38,2L0,2l0-2l40,0.1v26H8v-2h30V2z"/>
		<path class="st0" d="M20,9.1c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C24,10.8,22.2,9.1,20,9.1z M14,13.1
			c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6S14,16.4,14,13.1z"/>
		<path class="st0" d="M34,20.1v-3h2v5h-5v-2H34z"/>
		<path class="st0" d="M34,6h-3V4h5v5h-2V6z"/>
		<path class="st0" d="M4,12.1h6v2H4V12.1z"/>
		<path class="st0" d="M2,6h6v2H2V6z"/>
		<path class="st0" d="M6,18.1h6v2H6V18.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as FastPayout
};
